import { createFileRoute } from '@tanstack/react-router'
import '../App.css'
import Banner from '../components/Banner'
import Breadcrumb from '../components/Breadcrumb'
import USP from '../components/USP'
import WhyTrailfinders from '../components/WhyTrailfinders'
import FlightSearch from '../components/FlightSearch'
import PriceBoard from '../components/PriceBoard'
import MultiCentre from '../components/MultiCentre'
import { getCheapestFlights, getCheapestAllFlights, getMultiCentreFlights, getRTWFlights } from '../services/API'

export const Route = createFileRoute('/')({
  loader: async () => {
    const [flightsHot, allFlights, mcFlights, rtwFlights] = await Promise.all([
      getCheapestFlights(),
      getCheapestAllFlights(),
      getMultiCentreFlights(),
      getRTWFlights(),
    ])
    return { flightsHot, allFlights, mcFlights, rtwFlights }
  },
  component: IndexPage,
})

function FlightLinks() {
  const isIE = window?.siteVar?.referer === 'IE'
  return (
    <div className="container my-4">
      <div className="d-flex flex-wrap justify-content-center">
        {!isIE && (
          <a href="/special-offers/youth-and-gap-year-flights"
            className="btn btn-outline-dark rounded-1 p-2 p-md-3 m-1 m-lg-3 mobtwocol">
            Youth &amp; Gap Year Flights
          </a>
        )}
        <a href="/flights/stopovers"
          className="btn btn-outline-dark rounded-1 p-2 p-md-3 m-1 m-lg-3 mobtwocol">
          Stopovers
        </a>
        <a href="/blogs/holiday-styles/flights"
          className="btn btn-outline-dark rounded-1 p-2 p-md-3 m-1 m-lg-3 mobtwocol">
          Airline Blogs
        </a>
        <button
          onClick={() => document.getElementById('price-board')?.scrollIntoView({ behavior: 'smooth' })}
          className="btn btn-outline-dark rounded-1 p-2 p-md-3 m-1 m-lg-3 mobtwocol">
          Our Best Flight Deals
        </button>
      </div>
    </div>
  )
}

function IndexPage() {
  const { flightsHot, allFlights, mcFlights, rtwFlights } = Route.useLoaderData()

  return (
    <div className="d-flex flex-column container-fluid p-0">
      <Breadcrumb items={[]} />
      <Banner title="Flights" image="https://cdn.trailfinders.com/flights-hero.jpg">
        <FlightSearch destinations={allFlights.flatMap(c => c.destinations)} />
      </Banner>
      <USP />
      <PriceBoard flightsHot={flightsHot} allFlights={allFlights} />
      <MultiCentre mcFlights={mcFlights} rtwFlights={rtwFlights} />
      <FlightLinks />
      <WhyTrailfinders />
    </div>
  )
}
